import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { waitForFonts } from "./font-loader";

gsap.registerPlugin(ScrollTrigger, SplitText);

function initializeSplitText() {
  const splitElements = document.querySelectorAll(".split");

  splitElements.forEach((el) => {
    const split = new SplitText(el, {
      type: "words, chars",
      mask: "words",
      aria: false,
    });

    gsap.from(split.words, {
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        toggleActions: "play pause resume reverse",
      },
      duration: 0.5,
      y: 100,
      opacity: 0,
      stagger: 0.10,
      ease: "circ.out",
    });
  });

  const splitElementsCards = document.querySelectorAll(".split-cards");

  splitElementsCards.forEach((el) => {
    const split = new SplitText(el, {
      type: "words, chars",
      mask: "words",
      aria: false,
    });

    gsap.from(split.words, {
      scrollTrigger: {
        trigger: el,
        start: "top 70%",
        toggleActions: "play pause resume reverse",
      },
      duration: 0.5,
      y: 100,
      opacity: 0,
      stagger: 0.10,
      ease: "circ.out",
    });
  });
}

waitForFonts().then(() => {
  initializeSplitText();
});
